module.exports = __webpack_public_path__ + "spam1.png?3fb4d2c4c055597b404aebf551c1cd77";